import * as React from 'react';
import { Subscribe } from 'unstated';

import StateContainer from '../StateContainer';
import ProductVideos from './ProductVideos';

export interface IProductVideosTabProps {
  container: StateContainer;
  shouldUpdate: boolean;
}

export class ProductVideosTab extends React.Component<IProductVideosTabProps> {

  public shouldComponentUpdate() {
    return this.props.shouldUpdate;
  }

  public render() {
    const { container } = this.props;

    return (
      <Subscribe to={[container]}>
        {productDetail => (
          <ProductVideos
            onChange={(val: any) => container.onChange('videos', val)}
            productVideos={productDetail.state.product.videos}
            productId={productDetail.state.product.id}
            language={container.state.currentLanguage}
          />
        )}
      </Subscribe>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Products/ProductDetail/ProductVideosTab/ProductVideosTab.tsx